import * as React from 'react';
import { Box, Typography } from '@mui/material';
import QRCode from 'react-qr-code';

import { ReactComponent as MapMarkerSvg } from 'assets/images/map_marker_solid.svg';
import { ReactComponent as CleancodeDecalLogoSvg } from 'assets/images/logo_cleancode_decal.svg';

interface ApproveDecalProps {
  color?: string;
  size?: number;
  value?: string;
}

export const ApproveDecal: React.FC<ApproveDecalProps> = (props) => {
  const { color = '#FFA922', size = 80, value = 'cleancode' } = props;

  const circleSize = Math.sqrt(size * size * 2) + size * 0.2 * 2;
  const circlePosition = 20;

  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        border: `1px solid ${color}`,
        borderRadius: 1.5,
        overflow: 'hidden',
        width: '100%',
      }}
    >
      <Box
        sx={{
          backgroundColor: color,
          color: '#ffffff',
          textAlign: 'center',
          height: 64,
          position: 'relative',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: -12,
            left: 0,
            width: 240,
          }}
        >
          <CleancodeDecalLogoSvg />
        </Box>
      </Box>

      <Box
        sx={{
          textAlign: 'center',
          paddingX: 2,
          paddingY: 1.5,
        }}
      >
        <Typography
          sx={{
            fontSize: 11,
            maxWidth: 120,
            marginX: 'auto',
            lineHeight: 1.2,
          }}
        >
          Scan the QR code to view cleaning data
        </Typography>
      </Box>

      <Box
        sx={{
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            position: 'relative',
          }}
        >
          <MapMarkerSvg
            style={{
              width: circleSize + circlePosition * 2,
              color,
            }}
          />

          <Box
            sx={{
              position: 'absolute',
              top: circlePosition,
              left: circlePosition,
            }}
          >
            <Box
              sx={{
                width: circleSize,
                height: circleSize,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '100%',
                backgroundColor: '#ffffff',
                position: 'relative',
                paddingBottom: 1,
              }}
            >
              <QRCode size={size} value={value} />
              <Typography
                sx={{
                  position: 'absolute',
                  bottom: 12,
                  fontSize: 10,
                }}
              >
                # {value}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
